import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps, OutlinedInput, InputAdornment } from '@mui/material';
import Field from '../Field.js';
import { debounce } from '../../../cinnamon-core/es/modules/utility/debounce.js';
import connectForm$1 from '../../../cinnamon-core/es/components/forms/connectForm.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { prettifyField, omitProps, fieldErrors } from '../../../cinnamon-core/es/components/forms/utils.js';
import { requiredField } from '../../../cinnamon-core/es/components/forms/validators/requiredField.js';
import { number } from '../../../cinnamon-core/es/components/forms/validators/number.js';
import { minValue } from '../../../cinnamon-core/es/components/forms/validators/minValue.js';
import { maxValue } from '../../../cinnamon-core/es/components/forms/validators/maxValue.js';

var _templateObject;
var componentRoot = createComponentSlot({
  name: "CinFormNumeric",
  slot: "Root"
});

var NumericBase = /*#__PURE__*/function (_React$Component) {
  _inherits(NumericBase, _React$Component);

  var _super = _createSuper(NumericBase);

  function NumericBase(props) {
    var _this;

    _classCallCheck(this, NumericBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "applyChangeDebounced", undefined);

    _defineProperty(_assertThisInitialized(_this), "strip", function (incoming) {
      var _this$props = _this.props,
          decimalPlaces = _this$props.decimalPlaces,
          minValue = _this$props.minValue;
      var value = incoming.replace(/[^-\.\d]/g, ""); // only allow single .

      value = value.replace(/\./g, "|").replace("|", ".").replace(/\|/g, ""); // only allow single -

      value = value.replace(/-/g, "|").replace("|", "-").replace(/\|/g, ""); // limit negative values

      if (minValue !== undefined && minValue >= 0) {
        value = value.replace("-", "");
      } // limit decimal places


      if (decimalPlaces === 0) {
        value = value.replace(".", "");
      }

      if (decimalPlaces !== undefined && decimalPlaces > 0) {
        var pattern = "(\\.\\d{".concat(decimalPlaces, "})\\d*");
        var regex = new RegExp(pattern);
        return value.replace(regex, "$1");
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "applyChange", function (value) {
      if (_this.props.value === "" && value === "") return; // ensure only valid numbers

      var num = Number(value);

      if (Number.isNaN(num) || value === "") {
        num = null;
      }

      if (_this.props.value === num) return;

      _this.setState({
        lastChange: num
      }, function () {
        _this.props.onChange(num);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.setState({
        formatted: _this.strip(e.target.value)
      }, function () {
        _this.applyChangeDebounced ? _this.applyChangeDebounced(_this.state.formatted) : _this.applyChange(_this.state.formatted);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hasError", function (formatted) {
      var num = Number(formatted);
      return formatted !== "" && Number.isNaN(num);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      var blur = function blur() {
        if (_this.applyChangeDebounced) {
          _this.applyChangeDebounced.cancel();
        }

        _this.applyChange(_this.state.formatted);

        if (_this.props.onBlur) _this.props.onBlur(e);
      };

      var formatted = NumericBase.formatValue(e.target.value, _this.props);

      if (_this.hasError(formatted)) {
        _this.setState({
          formatted: ""
        }, blur);
      } else if (_this.props.formatValue) {
        _this.setState({
          formatted: formatted
        }, blur);
      } else {
        blur();
      }
    });

    _this.state = {
      formatted: NumericBase.formatValue(props.value, props),
      prev: props.value
    };

    if (props.debounce !== undefined && props.debounce !== 0) {
      _this.applyChangeDebounced = debounce(_this.applyChange, props.debounce);
    }

    return _this;
  }

  _createClass(NumericBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          errors = _this$props2.errors,
          showErrors = _this$props2.showErrors,
          allErrors = _this$props2.allErrors,
          animateErrors = _this$props2.animateErrors,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          renderReadOnly = _this$props2.renderReadOnly,
          label = _this$props2.label,
          labelProps = _this$props2.labelProps,
          actions = _this$props2.actions,
          size = _this$props2.size,
          width = _this$props2.width,
          fluid = _this$props2.fluid,
          required = _this$props2.required,
          subLabel = _this$props2.subLabel,
          subLabelPosition = _this$props2.subLabelPosition,
          passThruProps = _this$props2.passThruProps,
          forwardedRef = _this$props2.forwardedRef,
          className = _this$props2.className;
      var formatted = this.state.formatted;
      var muiProps = omitProps(passThruProps, Object.keys(NumericBase.propTypes));
      var adornmentProps = {};

      if (subLabel) {
        var right = subLabelPosition === "right";

        if (right) {
          adornmentProps.endAdornment = /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, subLabel);
        } else {
          adornmentProps.startAdornment = /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, subLabel);
        }
      }

      var fieldLabelProps = _objectSpread2({
        variant: readOnly && renderReadOnly ? "field" : "input"
      }, labelProps);

      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && renderReadOnly ? function () {
          return renderReadOnly(_this2.props, _this2.state);
        } : false,
        size: size,
        width: width,
        fluid: fluid,
        label: label,
        labelProps: fieldLabelProps,
        actions: actions,
        errors: fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors,
        className: classnames(componentRoot.className, className),
        ref: forwardedRef
      }, /*#__PURE__*/React.createElement(OutlinedInput, _extends({}, adornmentProps, muiProps, {
        value: formatted !== null ? formatted : "",
        onChange: this.onChange,
        onBlur: this.onBlur,
        label: fieldLabelProps.variant === "input" ? label : undefined,
        multiline: false,
        readOnly: readOnly,
        error: this.hasError(formatted) ? true : undefined
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // apply external value changes
      if (props.value !== state.prev && props.value !== state.formatted) {
        if (props.value === state.lastChange) {
          // change was triggered by this field
          return {
            prev: props.value,
            lastChange: undefined
          };
        }

        return {
          formatted: NumericBase.formatValue(props.value, props),
          prev: props.value,
          lastChange: undefined
        };
      }

      return {
        prev: props.value
      };
    }
  }, {
    key: "formatValue",
    value: function formatValue(value, props) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      var decimalPlaces = props.decimalPlaces,
          formatValue = props.formatValue,
          minValue = props.minValue,
          maxValue = props.maxValue;
      var num = Number(value);

      if (!formatValue || Number.isNaN(num)) {
        return value.toString();
      }

      if (typeof minValue === "number") {
        num = Math.max(num, minValue);
      }

      if (typeof maxValue === "number") {
        num = Math.min(num, maxValue);
      }

      return decimalPlaces !== undefined && decimalPlaces >= 0 ? num.toFixed(decimalPlaces) : num.toString();
    }
  }]);

  return NumericBase;
}(React.Component);

_defineProperty(NumericBase, "propTypes", {
  notifiedFields: propTypes.arrayOf(propTypes.string),
  customValidator: propTypes.func,
  customErrors: propTypes.arrayOf(propTypes.string),
  readOnly: propTypes.bool,
  disabled: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  allErrors: propTypes.bool,
  showErrors: propTypes.bool,
  field: propTypes.string.isRequired,
  maxValueError: propTypes.string,
  maxValue: propTypes.number,
  minValueError: propTypes.string,
  minValue: propTypes.number,
  numberError: propTypes.string,
  numberValidation: propTypes.bool.isRequired,
  requiredError: propTypes.string,
  required: propTypes.bool,
  variant: propTypes.any,
  sx: propTypes.any,
  className: propTypes.string,
  formatValue: propTypes.bool,
  decimalPlaces: propTypes.number,
  subLabelPosition: propTypes.oneOf(["left", "right"]),
  subLabel: propTypes.node,
  debounce: propTypes.number,
  renderReadOnly: propTypes.func,
  fluid: propTypes.bool,
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  actions: propTypes.node,
  labelProps: propTypes.any,
  label: propTypes.node
});

_defineProperty(NumericBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedNumeric = connectForm$1({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  },
  validators: [requiredField(false), number(true), minValue(), maxValue()]
})(NumericBase);
var NumericRoot = styled(ConnectedNumeric, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
NumericRoot.defaultProps = {
  formatValue: false,
  variant: "outlined"
};
/**
 * Field for a numeric value
 */

var Numeric = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(NumericRoot, _extends({}, rootProps, {
    ref: ref
  }));
});
Numeric.defaultProps = {
  numberValidation: true
};
var Numeric$1 = Numeric;

export { Numeric$1 as default };
